/* eslint-disable */
import Oidc from 'oidc-client';

//metadataUrl: 'https://localhost:6001/.well-known/openid-configuration',
//var mgr = new Oidc.UserManager({
//    authority: 'https://localhost:6001',
//    metadataUrl: 'https://localhost:6001/.well-known/openid-configuration',
//    userStore: new Oidc.WebStorageStateStore(),   
//    client_id: 'vrs-remote',
//    redirect_uri: window.location.origin + '/static/callback.html',
//    response_type: 'id_token token',
//    scope: 'openid profile email vrs',
//    post_logout_redirect_uri: window.location.origin + '/index.html',
//    silent_redirect_uri: window.location.origin + '/static/silent-renew.html',
//    accessTokenExpiringNotificationTime: 300,
//    automaticSilentRenew: false,
//    filterProtocolClaims: true,
//    loadUserInfo: true
//})
var mgr=null;
async function getUserManager() {
    if(mgr) {
        return mgr;
    }
    let response = await fetch("/api/system/oidc");
    let config = await response.json();
    
    config.userStore=new Oidc.WebStorageStateStore();
    config.redirect_uri=window.location.origin+config.redirect_uri;
    config.post_logout_redirect_uri=window.location.origin+config.post_logout_redirect_uri;
    config.silent_redirect_uri=window.location.origin+config.silent_redirect_uri;
    mgr = new Oidc.UserManager(config);
    Oidc.Log.logger = console;
    Oidc.Log.level = Oidc.Log.INFO;

    mgr.events.addUserLoaded(function (user) {
        localStorage.setItem("userName", user.profile.name);
    });

    mgr.events.addAccessTokenExpiring(function () {
        console.log('AccessToken Expiring：', arguments);
    });

    mgr.events.addAccessTokenExpired(function () {
        console.log('AccessToken Expired：', arguments);
        alert('Session expired. Going out!');
        mgr.signoutRedirect().then(function (resp) {
            console.log('signed out', resp);
        }).catch(function (err) {
            console.log(err)
        })
    });

    mgr.events.addSilentRenewError(function () {
        console.error('Silent Renew Error：', arguments);
    });

    mgr.events.addUserSignedOut(function () {
        alert('Going out!');
        console.log('UserSignedOut：', arguments);
        mgr.signoutRedirect().then(function (resp) {
            console.log('signed out', resp);
        }).catch(function (err) {
            console.log(err)
        })
    });
    return mgr;
}


export default class SecurityService {

    // Renew the token manually
    async renewToken () {
        let self = this;
        let usrMgr=await getUserManager();
        try {
            let user = await usrMgr.signinSilent();
            if(user==null) {
                await self.signIn(null);
            }
            else {
                return user;
            }
        }
        catch(err) {
            console.log(`Error raised on renewToken(): ${err}`);
            await self.signIn();
            throw err;
        }
    }

    // Redirect of the current window to the authorization endpoint.
    async signIn () {
        let usrMgr=await getUserManager();
        try {
            await usrMgr.signinRedirect();
        }
        catch(err) {
            console.log(`Error raised on signIn(): ${err}`);
            throw err;
        }
    }

    // Redirect of the current window to the end session endpoint
    async signOut () {
        let usrMgr=await getUserManager();
        try {
            await usrMgr.signoutRedirect();
        }
        catch(err) {
            console.log(`Error raised on signOut(): ${err}`);
            throw err;
        }
    }

    // Get the profile of the user logged in
    async getProfile () {
        let self = this;
        let usrMgr=await getUserManager();
        try {
            let user = await usrMgr.getUser();
            if(user==null) {
                await self.signIn();
                return null;
            }
            else {
                // set users role to current page role
                const urlParams = new URLSearchParams(document.referrer);
                const deptID = urlParams.get('DepartmentId')
                user.profile.DepartmentId = deptID;
                return user.profile;
            }
        }
        catch(err) {
            console.log(`Error raised on getProfile(): ${err}`);
            throw err;
        }
    }

    // Get the token id
    async getIdToken(){
        let self = this;
        let usrMgr=await getUserManager();
        try {
            let user = await usrMgr.getUser();
            if(user==null) {
                await self.signIn();
                return null;
            }
            else {
                return user.id_token;
            }
        }
        catch(err) {
            console.log(`Error raised on getIdToken(): ${err}`);
            throw err;
        }
    }

    async getUsername() {
        let self = this;
        let usrMgr=await getUserManager();
        try {
            let user = await usrMgr.getUser();
            if(user==null) {
                await self.signIn();
                return null;
            }
            else {
                return user.profile.preferred_username.split("@")[0];
            }
        }
        catch(err) {
            console.log(`Error raised on getUsername(): ${err}`);
            throw err;
        }
    }
}
